import http, {makeSearchParams} from 'utils/http';

export const getCertifiedEntities = (data) => {
  return http('GET', 'ce', makeSearchParams(data));
};

export const getCertificates = (id, data) => {
  return http('GET', `g/ce/${id}/certifications`, makeSearchParams(data));
};

export const getPublicCertifiedEntities = (params) => {
  return http('GET', 'g/ce', makeSearchParams(params));
};

export const getPublicCertifiedEntity = (id) => {
  return http('GET', `g/ce/${id}`);
};

export const getProducts = (id, data) => {
  return http(
    'POST',
    `https://api.qualitytrade.com/api/v1/search/company/products/${id}`,
    data
  );
};

export const deleteAllCertificationsfromCB = (id, data) => {
  return http('DELETE', `ce/${id}/certifications`, data);
};

// Deactivate & Delete CE

export const deactivateCEAccount = () => {
  return http('DELETE', 'ce/deactivate');
};

export const deleteCEAccount = () => {
  return http('DELETE', 'ce/account');
};

export const getCEMarketplace = () => {
  return http('GET', '/ce/marketplace');
};

export const deleteCEMarketplace = () => {
  return http('DELETE', '/ce/marketplace');
};

/**
 *
 * @param data = {"app_id":"557a6687-7dc8-11e9-b3cc-0a77febb3334","consent":{"qt":{"status":1,"version":"1.1"}}}
 * @returns {*}
 */
export const postCEMarketplaceOTC = (data) => {
  return http('POST', 'ce/marketplace/otc', data);
};

export const deleteCertifiedEntitiesCerts = (id, data) => {
  return http('POST', `ce/${id}/certifications/delete-permanently-bulk`, data);
};

/**
 * Get CE sites
 * @param {*} ceId
 * @returns sites
 */
export const getCESites = (ceId, queries) => {
  return http('GET', `ce/${ceId}/sites`, makeSearchParams(queries));
};

/**
 * Add CE sites
 * @param {*} ceId
 * @param {*} data
 * @returns number
 */
export const postCESites = (ceId, data) => {
  return http('POST', `ce/${ceId}/sites`, data);
};
